import { z } from 'zod';

/**
 * Wire formats for Nominatim and Open-Elevation. Field names stay snake_case on
 * purpose — these responses do not pass through the `humps` interceptors that
 * `ApiClient` installs (see NominatimService for why we bypass `ApiClient`).
 */

/** `boundingbox` arrives as `[minLat, maxLat, minLon, maxLon]` decimal strings. */
export const nominatimBoundingBoxSchema = z.tuple([z.string(), z.string(), z.string(), z.string()]);

export const nominatimPlaceSchema = z.object({
  lat: z.string(),
  lon: z.string(),
  display_name: z.string(),
  boundingbox: nominatimBoundingBoxSchema.optional(),
  addresstype: z.string().nullish(),
  place_rank: z.number().nullish(),
  category: z.string().nullish(),
  type: z.string().nullish(),
  osm_id: z.number().nullish(),
});
export type NominatimPlace = z.infer<typeof nominatimPlaceSchema>;

/** An empty array is a valid "no hit" response. */
export const nominatimSearchResponseSchema = z.array(nominatimPlaceSchema);

export const elevationResultSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  elevation: z.number(),
});

export const elevationResponseSchema = z.object({
  results: z.array(elevationResultSchema),
});
export type ElevationResponse = z.infer<typeof elevationResponseSchema>;
